// Module
var code = "<h2 id=\"loan-default\">Loan Default</h2> <p>Find out what options are available if you currently have loans in default. </p> ";
// Exports
export default code;